export const USER_ACCESS_FILTER_GROUPS = [
  {
    id: 'access',
    title: 'Access type',
    hint: 'Matches the Access column — trial, pilot, or Stripe. Pick any; results combine with OR inside this group.',
    options: [
      {
        value: 'trial',
        label: 'Free trial',
        description: 'Active trial period',
      },
      {
        value: 'welcome_pilot',
        label: 'Welcome pilot',
        description: '15-day signup access (Pilot Full)',
      },
      {
        value: 'admin_pilot',
        label: 'Admin-granted pilot',
        description: 'Override set by an admin',
      },
      {
        value: 'pilot_full',
        label: 'Pilot Full (any)',
        description: 'Welcome or admin Pilot Full override',
      },
      {
        value: 'pilot_basic',
        label: 'Pilot Basic',
        description: 'Basic-only pilot override',
      },
      {
        value: 'manual_custom',
        label: 'Manual custom',
        description: 'Basic + admin-selected add-ons',
      },
      {
        value: 'stripe_active',
        label: 'Stripe subscription',
        description: 'Non-terminal paid subscription on file',
      },
      {
        value: 'no_access',
        label: 'No plan / access',
        description: 'No trial, pilot, billing, or catalog plan',
      },
    ],
  },
  {
    id: 'billing',
    title: 'Billing plan (catalog)',
    hint: 'Mongo user.plan SKU only — not pilot overrides. OR within this group.',
    options: [
      {
        value: 'billing_basic',
        label: 'Basic',
        description: 'Billing plan is Basic',
      },
      {
        value: 'billing_all_in_one',
        label: 'All-in-One Bundle',
        description: 'Billing plan is bundle SKU',
      },
    ],
  },
  {
    id: 'addons',
    title: 'Add-ons',
    hint: 'Paid add-on line items (or bundle, which includes all). OR within this group.',
    options: [
      {
        value: 'has_trips',
        label: 'Has Trips',
        description: 'Trips add-on or All-in-One',
      },
      {
        value: 'has_zones',
        label: 'Has Zones',
        description: 'Zones add-on or All-in-One',
      },
      {
        value: 'has_report',
        label: 'Has Report',
        description: 'Report add-on or All-in-One',
      },
    ],
  },
];

export const ALL_ACCESS_FILTER_OPTIONS = USER_ACCESS_FILTER_GROUPS.flatMap(
  (group) => group.options,
);

export const getAccessFilterLabel = (value) => (
  ALL_ACCESS_FILTER_OPTIONS.find((option) => option.value === value)?.label || value
);
